/* eslint-disable no-await-in-loop */
import React, { useState } from 'react';
import Button from '@atlaskit/button';
import styled from 'styled-components';
import ExcelSpreadsheet16Icon from '@atlaskit/icon-file-type/glyph/excel-spreadsheet/16';
import { SuccessProgressBar } from '@atlaskit/progress-bar';
import { CSVLink } from 'react-csv';

import CustomizeModal from '../modal/CustomizeModal';
import { ProgressBarContainer } from '../styles/styles';
import { getJobs } from '../../services/JobService';

const ExportBtnContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }

  &.margin-above {
    margin-top: 32px;
  }

  &.margin-below {
    margin-bottom: 30px;
  }

  &.margin-left {
    margin-left: -30px;
  }
`;

type iExportReport = {
  className?: string;
  total?: number;
  perPage?: number;
  config?: {
    filter?: string;
    like?: string;
    sort?: string;
  };
  getFn?: (currentPage: number) => Promise<string>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFormatReport: (arr: any[]) => (string | number | true)[][];
  reportFileName: string;
};
const ExportReport = ({
  className,
  total = 1,
  perPage = 10,
  config,
  getFn,
  onFormatReport,
  reportFileName,
}: iExportReport) => {
  const [isProgressBarModalOpen, setIsProgressBarModalOpen] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [report, setReport] = useState<any[]>([]);

  const onGenerateReport = async () => {
    const totalPageSize = Math.ceil(total / perPage);
    const reportData = [];
    setIsProgressBarModalOpen(true);
    for (let i = 1; i <= totalPageSize; i++) {
      const { data } = typeof getFn === 'function' ? await getFn(i) : await getJobs(i, perPage, config || {});
      reportData.push(...data);
      setExportProgress(i / totalPageSize);
    }

    const finalReport = onFormatReport(reportData);
    setReport(finalReport);
  };

  const getCSVLink = () => (
    <CSVLink data={report} filename={reportFileName}>
      <Button
        appearance={'primary'}
        isDisabled={exportProgress < 1}
        onClick={() => setIsProgressBarModalOpen(false)}
        style={{ textDecoration: 'none' }}
      >
        Download Report
      </Button>
    </CSVLink>
  );

  const getProgressBar = () => (
    <ProgressBarContainer>
      <SuccessProgressBar value={exportProgress} />
    </ProgressBarContainer>
  );

  const onCancelProgressBar = () => {
    setIsProgressBarModalOpen(false);
    setExportProgress(0);
  };

  return (
    <>
      <ExportBtnContainer onClick={onGenerateReport} className={className}>
        <ExcelSpreadsheet16Icon label={'Export Report'} testId={'exportReportBtn'} />
      </ExportBtnContainer>
      <CustomizeModal
        isOpen={isProgressBarModalOpen}
        customizedBtn={getCSVLink()}
        onCancel={onCancelProgressBar}
        modalBody={getProgressBar()}
        modalHeading={exportProgress === 1 ? 'Completed' : 'Exporting...'}
      />
    </>
  );
};

export default ExportReport;
